/**
 * The vocabulary of the graph as the GUI shows it: the shapes node kinds are drawn with (kinds
 * themselves come from plugins, `kinds.ts`; the fields nodes carry from environments,
 * `fields.ts`; categories, made by people, are in `categories.ts`). Taken from the prototype (`docs/prototype`).
 */
import type { NodeShape } from "@protocol/NodeShape";

/** SVG markup (16×16 view box) of each shape a node kind can take in the nodal view. */
export const SHAPES: Record<NodeShape, string> = {
  circle: '<circle cx="8" cy="8" r="5.2" fill="currentColor"/>',
  square: '<rect x="3" y="3" width="10" height="10" rx="1" fill="currentColor"/>',
  diamond: '<path d="M8 1.5L14.5 8L8 14.5L1.5 8z" fill="currentColor"/>',
  hexagon: '<path d="M8 1.5l5.6 3.2v6.6L8 14.5l-5.6-3.2V4.7z" fill="currentColor"/>',
  triangle: '<path d="M8 2L14 13.5H2z" fill="currentColor"/>',
  rounded: '<rect x="2.5" y="2.5" width="11" height="11" rx="3.5" fill="currentColor"/>',
  ring: '<circle cx="8" cy="8" r="5" fill="none" stroke="currentColor" stroke-width="2"/>',
  halo: '<circle cx="8" cy="8" r="3.6" fill="currentColor"/><circle cx="8" cy="8" r="6.4" fill="none" stroke="currentColor" stroke-width="1.2" opacity=".7"/>',
};

